import Create from './actions/create';
import Delete from './actions/delete';
import Resource from './resource';

export default class ITA extends Resource {
  get resourcesName() {
    return 'ita';
  }
  get resourceName() {
    return 'ita';
  }

  install() {
    const options = {
      method: 'POST',
      path: this.collectionAction('install', null),
    };

    return this.call(options);
  }

  delete() {
    const options = {
      method: 'DELETE',
      path: this.collectionAction('destroy', null),
    };

    return this.call(options);
  }
}
// @ts-ignore
Create.includeInto(ITA);
// @ts-ignore
Delete.includeInto(ITA);
